import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TaskReservationService {
  public readonly timeoutSeconds$ = new BehaviorSubject<number>(0);
}
